import { Component, EventEmitter, HostBinding, Inject, Input, Output } from '@angular/core';
import { CommonModule, DOCUMENT, NgStyle } from '@angular/common';
import { PcButtonIcon } from '@pc/common';
import { LanguageDirection } from '@pc/translation';

@Component({
  selector: 'pc-back-btn',
  standalone: true,
  imports: [CommonModule, NgStyle],
  templateUrl: './back-btn.component.html',
  styleUrls: ['./back-btn.component.scss']
})
export class BackBtnComponent {
  @Output() backClicked = new EventEmitter<undefined>();

  @Input() withIcon = true;
  @Input() oppositeIconPlacement = false;

  @Input() text = '';
  @Input() ariaText = '';
  @Input() color: string | undefined;
  @Input() fontSize: string | undefined;
  @Input() fontWeight: string | undefined;
  @Input() icon = PcButtonIcon.LEFT_CHEVRON;
  @Input() textPadding = '';
  @Input() size = 'small';
  @Input() direction = LanguageDirection.RTL;

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.direction = this.document.documentElement.dir as LanguageDirection;
  }

  @HostBinding('class')
  get class(): string {
    return `size--${this.size}`;
  }

  onClick() {
    this.backClicked.emit();
  }
}
